import React from "react"
import { Tabber, TabberVariant, TabItem } from "../../../designSystem/Tabber";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { Label } from "../../../designSystem/Label";

export const TabOverview = (): JSX.Element => 
{
    const [selectedTab, setSelectedTab] = React.useState<string>('Tab1');

    const items:TabItem[] = [
        {tabName:'Tab1', text:'Tab 1', leadingContent:'data_files_file'},
        {tabName:'Tab2', text:'Tab 2', leadingContent:'eco', avatarCount:64},
        {tabName:'Tab3', text:'Tab 3', avatarCount:4},
        {tabName:'Tab4', text:'Tab 4', leadingContent:'earthquake', disabled:true},
    ];

    return (
        <Flex flexDirection="column" gap={48}>
            {['default', 'slim', 'text', 'text-minimal'].map(variant => 
                <div key={variant} style={{border:'1px solid #000', padding: '16px', borderRadius:'4px' }}>
                    {[true,false].map(inline => 
                        <div key={variant + '_' + inline.toString()}>
                            
                            <Label>{variant} | inline: {inline.toString()}</Label>
                            <Tabber
                                items={items}
                                selectedTabName={selectedTab}
                                onClick={(tabName) => setSelectedTab(tabName)}
                                variant={variant as TabberVariant}
                                inline={inline}
                            />

                        </div>
                    )}
                </div>
            )}
        </Flex>
    )
}
